import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { Product } from './components/product';
import { Products } from './components/products';
import { productsPaths } from './productsPaths';

export const productsRoutes = [
  {
    path: `${productsPaths.root}/*`,
    element: <Products />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag',
      },
      requiredPermission: Permissions.globalAdmin,
    },
    children: [],
  },
  {
    path: `${productsPaths.root}/:productId`,
    element: <Product />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag-outline',
      },
      requiredPermission: Permissions.product.all,
    },
    children: [],
  },
];
